export default "__VITE_ASSET__59fdb109__"